export const basicTypeHeadData = [
    {
      text: "This is the simple demo for Typeahead.",
    },
  ];
  
  export const stateOfUsa = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];
  
  export const preFetchData = [
    {
      text: "Prefetched data is fetched and processed on initialization",
    },
  ];
  
  export const countryDataList = [
    "Andorra",
    "United Arab Emirates",
    "Afghanistan",
    "Antigua and Barbuda",
    "Anguilla",
    "Albania",
    "Armenia",
    "Angola",
    "Antarctica",
    "Argentina",
    "American Samoa",
    "Austria",
    "Australia",
    "Aruba",
    "Åland",
    "Azerbaijan",
    "Bosnia and Herzegovina",
    "Barbados",
    "Bangladesh",
    "Belgium",
    "Burkina Faso",
    "Bulgaria",
    "Bahrain",
    "Burundi",
    "Benin",
    "Saint Barthélemy",
    "Bermuda",
    "Brunei",
    "Bolivia",
    "Bonaire",
    "Brazil",
    "Bahamas",
    "Bhutan",
    "Bouvet Island",
    "Botswana",
    "Belarus",
    "Belize",
    "Canada",
    "Cocos [Keeling] Islands",
    "Congo",
    "Central African Republic",
    "Republic of the Congo",
    "Switzerland",
    "Ivory Coast",
    "Cook Islands",
    "Chile",
    "Cameroon",
    "China",
    "Colombia",
    "Costa Rica",
    "Cuba",
    "Cape Verde",
    "Curacao",
    "Christmas Island",
    "Cyprus",
    "Czechia",
    "Germany",
    "Djibouti",
    "Denmark",
    "Dominica",
    "Dominican Republic",
    "Algeria",
    "Ecuador",
    "Estonia",
    "Egypt",
    "Western Sahara",
    "Eritrea",
    "Spain",
    "Ethiopia",
    "Finland",
    "Fiji",
    "Falkland Islands",
    "Micronesia",
    "Faroe Islands",
    "France",
    "Gabon",
    "United Kingdom",
    "Grenada",
    "Georgia",
    "French Guiana",
    "Guernsey",
    "Ghana",
    "Gibraltar",
    "Greenland",
    "Gambia",
    "Guinea",
    "Guadeloupe",
    "Equatorial Guinea",
    "Greece",
    "South Georgia and the South Sandwich Islands",
    "Guatemala",
    "Guam",
    "Guinea-Bissau",
    "Guyana",
    "Hong Kong",
    "Heard Island and McDonald Islands",
    "Honduras",
    "Croatia",
    "Haiti",
    "Hungary",
    "Indonesia",
    "Ireland",
    "Israel",
    "Isle of Man",
    "India",
    "British Indian Ocean Territory",
    "Iraq",
    "Iran",
    "Iceland",
    "Italy",
    "Jersey",
    "Jamaica",
    "Jordan",
    "Japan",
    "Kenya",
    "Kyrgyzstan",
    "Cambodia",
    "Kiribati",
    "Comoros",
    "Saint Kitts and Nevis",
    "North Korea",
    "South Korea",
    "Kuwait",
    "Cayman Islands",
    "Kazakhstan",
    "Laos",
    "Lebanon",
    "Saint Lucia",
    "Liechtenstein",
    "Sri Lanka",
    "Liberia",
    "Lesotho",
    "Lithuania",
    "Luxembourg",
    "Latvia",
    "Libya",
    "Morocco",
    "Monaco",
    "Moldova",
    "Montenegro",
    "Saint Martin",
    "Madagascar",
    "Marshall Islands",
    "Macedonia",
    "Mali",
    "Myanmar [Burma]",
    "Mongolia",
    "Macao",
    "Northern Mariana Islands",
    "Martinique",
    "Mauritania",
    "Montserrat",
    "Malta",
    "Mauritius",
    "Maldives",
    "Malawi",
    "Mexico",
    "Malaysia",
    "Mozambique",
    "Namibia",
    "New Caledonia",
    "Niger",
    "Norfolk Island",
    "Nigeria",
    "Nicaragua",
    "Netherlands",
    "Norway",
    "Nepal",
    "Nauru",
    "Niue",
    "New Zealand",
    "Oman",
    "Panama",
    "Peru",
    "French Polynesia",
    "Papua New Guinea",
    "Philippines",
    "Pakistan",
    "Poland",
    "Saint Pierre and Miquelon",
    "Pitcairn Islands",
    "Puerto Rico",
    "Palestine",
    "Portugal",
    "Palau",
    "Paraguay",
    "Qatar",
    "Réunion",
    "Romania",
    "Serbia",
    "Russia",
    "Rwanda",
    "Saudi Arabia",
    "Solomon Islands",
    "Seychelles",
    "Sudan",
    "Sweden",
    "Singapore",
    "Saint Helena",
    "Slovenia",
    "Svalbard and Jan Mayen",
    "Slovakia",
    "Sierra Leone",
    "San Marino",
    "Senegal",
    "Somalia",
    "Suriname",
    "South Sudan",
    "São Tomé and Príncipe",
    "El Salvador",
    "Sint Maarten",
    "Syria",
    "Swaziland",
    "Turks and Caicos Islands",
    "Chad",
    "French Southern Territories",
    "Togo",
    "Thailand",
    "Tajikistan",
    "Tokelau",
    "East Timor",
    "Turkmenistan",
    "Tunisia",
    "Tonga",
    "Turkey",
    "Trinidad and Tobago",
    "Tuvalu",
    "Taiwan",
    "Tanzania",
    "Ukraine",
    "Uganda",
    "U.S. Minor Outlying Islands",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vatican City",
    "Saint Vincent and the Grenadines",
    "Venezuela",
    "British Virgin Islands",
    "U.S. Virgin Islands",
    "Vietnam",
    "Vanuatu",
    "Wallis and Futuna",
    "Samoa",
    "Kosovo",
    "Yemen",
    "Mayotte",
    "South Africa",
    "Zambia",
    "Zimbabwe",
  ];
  
  export const bloodHoundData = [
    {
      text: "Bloodhound offers advanced functionalities such as prefetching and backfilling with remote data.",
    },
  ];
  
  export const remoteTypeHeadData = [
    {
      text: "Remote data is only used when the data provided by local and prefetch is insufficient",
    },
  ];
  
  export const moviesList = [
    "Around the World in 80 Days",
    "All Quiet on the Western Front",
    "Gentleman's Agreement",
    "All the Kings Men",
    "All About Eve",
    "An American in Paris",
    "The Apartment",
    "The Broadway Melody",
    "Mutiny on the Bounty",
    "The Best Years of Our Lives",
    "The Bridge on the River Kwai",
    "Ben-Hur",
    "Cimarron",
    "Cavalcade",
    "You Can't Take It with You",
    "Casablanca",
    "The Life of Emile Zola",
    "The Greatest Show on Earth",
    "From Here to Eternity",
    "Grand Hotel",
    "The Great Ziegfeld",
    "Gone with the Wind",
    "How Green Was My Valley",
    "Going My Way",
    "Gigi",
    "It Happened One Night",
    "Hamlet",
    "Mrs. Miniver",
    "Marty",
    "Rebecca",
    "Wings",
  ];
  
  export const customTemplateData = [
    {
      text: "Custom templates give you full control over how suggestions get rendered",
    },
  ];
  
  export const oscarWinnerData = [
    "West Side Story",
    "Lawrence of Arabia",
    "Tom Jones",
    "My Fair Lady",
    "The Sound of Music",
    "A Man for All Seasons",
    "In the Heat of the Night",
    "Oliver!",
    "Midnight Cowboy",
    "Patton",
    "The French Connection",
    "The Godfather",
    "The Sting",
    "The Godfather Part II",
    "One Flew over the Cuckoo's Nest",
    "Rocky",
    "Annie Hall",
    "The Deer Hunter",
    "Kramer vs. Kramer",
    "Ordinary People",
    "Chariots of Fire",
    "Gandhi",
    "Terms of Endearment",
    "Amadeus",
    "Out of Africa",
    "Platoon",
    "The Last Emperor",
    "Rain Man",
    "Driving Miss Daisy",
    "Dances With Wolves",
    "The Silence of the Lambs",
    "Unforgiven",
    "Schindler’s List",
    "Forrest Gump",
    "Braveheart",
    "The English Patient",
    "Titanic",
    "Shakespeare in Love",
    "American Beauty",
    "Gladiator",
    "A Beautiful Mind",
    "Chicago",
    "The Lord of the Rings: The Return of the King",
    "Million Dollar Baby",
    "Crash",
    "The Departed",
    "No Country for Old Men",
    "Slumdog Millionaire",
    "The Hurt Locker",
    "The King's Speech",
    "The Artist",
    "Argo",
  ];
  
  export const multipleSectionHeaderData = [
    {
      text: "Two datasets that are prefetched, stored, and searched on the client. Highlighting is enabled.",
    },
  ];
  
  export const multiWithHeaderData = [
    { name: "NBA Teams", header: true },
    { name: "Boston Celtics" },
    { name: "Dallas Mavericks" },
    { name: "Brooklyn Nets" },
    { name: "Houston Rockets" },
    { name: "New York Knicks" },
    { name: "Memphis Grizzlies" },
    { name: "Philadelphia 76ers" },
    { name: "New Orleans Hornets" },
    { name: "Toronto Raptors" },
    { name: "San Antonio Spurs" },
    { name: "Chicago Bulls" },
    { name: "Denver Nuggets" },
    { name: "Cleveland Cavaliers" },
    { name: "Minnesota Timberwolves" },
    { name: "Detroit Pistons" },
    { name: "Portland Trail Blazers" },
    { name: "Indiana Pacers" },
    { name: "Oklahoma City Thunder" },
    { name: "Milwaukee Bucks" },
    { name: "Utah Jazz" },
    { name: "Atlanta Hawks" },
    { name: "Golden State Warriors" },
    { name: "Charlotte Bobcats" },
    { name: "Los Angeles Clippers" },
    { name: "Miami Heat" },
    { name: "Los Angeles Lakers" },
    { name: "Orlando Magic" },
    { name: "Phoenix Suns" },
    { name: "Washington Wizards" },
    { name: "Sacramento King" },
    { name: "", divider: true },
    { name: "NHL Teams", header: true },
    { name: "Boston Celtics" },
    { name: "Dallas Mavericks" },
    { name: "Brooklyn Nets" },
    { name: "Houston Rockets" },
    { name: "New York Knicks" },
    { name: "Memphis Grizzlies" },
    { name: "Philadelphia 76ers" },
    { name: "New Orleans Hornets" },
    { name: "Toronto Raptors" },
    { name: "San Antonio Spurs" },
    { name: "Chicago Bulls" },
    { name: "Denver Nuggets" },
    { name: "Cleveland Cavaliers" },
    { name: "Minnesota Timberwolves" },
    { name: "Detroit Pistons" },
    { name: "Portland Trail Blazers" },
    { name: "Indiana Pacers" },
    { name: "Oklahoma City Thunder" },
    { name: "Milwaukee Bucks" },
    { name: "Utah Jazz" },
    { name: "Atlanta Hawks" },
    { name: "Golden State Warriors" },
    { name: "Charlotte Bobcats" },
    { name: "Los Angeles Clippers" },
    { name: "Miami Heat" },
    { name: "Los Angeles Lakers" },
    { name: "Orlando Magic" },
    { name: "Phoenix Suns" },
    { name: "Washington Wizards" },
    { name: "Sacramento King" },
  ];

  export const scrollableDropdownData = [
    {
      text: "Dataset shows in scrollable dropdown menu.",
    },
  ];
  
  export const rtlSupportData = [
    {
      text: "Dataset shows in Right Side.",
    },
  ];